import * as THREE from 'three'
import Experience from '../Experience';
import gsap from 'gsap'
import EventEmitter from './EventEmitter.js'

export default class UISegmentOne 
{
    constructor()
    {
        this.experience = new Experience();
        this.resources = this.experience.resources;
        this.world = this.experience.world;
        this.camera = this.experience.camera;
        this.sizes = this.experience.sizes;

        this.screenHelpPosition;
        this.translateX;
        this.translateY;
        this.dotSelected = 0;
        this.legendTxt = document.querySelector('.legend1')
        this.tags = {};
        this.dotState1 = false;
        this.dotState2 = false;
        this.dotState3 = false;
        this.dotState4 = false;
        this.dotState5 = false;
        this.dotState6 = false;
        this.dotState7 = false;
        this.dotState8 = false;
        this.dotState9 = false;
        this.dotState10 = false;        
        this.dotOffset = new THREE.Vector3(0,0,0);
        this.dotOffset1 = new THREE.Vector3(0,-3.5,0);
        this.panelContentShowed= false;
        this.infoShowed = false;
        this.infoContent = document.querySelector('.infoBtn1');
        this.infoButton = document.getElementById("info1");
        this.infoButton.addEventListener("click",()=>{
            this.infoBehaviour();
        });
        this.linkPanel1 = document.querySelector('.ddSegment1');
        this.contentPanel1 = document.querySelector(".ddcSegment1");
        this.btnLinkPanel1 = document.getElementById("btnLinkPanelOne");
        this.btnLinkPanel1.addEventListener("click", ()=>{
            if(!this.panelContentShowed)
            {
                this.contentPanel1.classList.add('visible');
                this.btnLinkPanel1.classList.add('rot');
                this.experience.ui.dropState = 1;
                this.resetInfo();
            }
            else
            {
                this.contentPanel1.classList.remove('visible');
                this.btnLinkPanel1.classList.remove('rot');
                this.experience.ui.dropState = -1;
            }
            this.panelContentShowed = !this.panelContentShowed;
        })
        document.addEventListener("click", (evt) => {            
            let targetEl = evt.target; 
            if((targetEl == this.experience.canvas))
            {                
                if(this.panelContentShowed)
                {
                    this.contentPanel1.classList.remove('visible');
                    this.btnLinkPanel1.classList.remove('rot');
                    this.experience.ui.dropState = -1;
                    this.panelContentShowed = !this.panelContentShowed;
                }
                if(this.infoShowed)
                {
                    this.legendTxt.classList.remove('visible');
                    this.infoButton.classList.remove('selected');
                    this.experience.ui.dropState = -1;
                    this.experience.ui.secondIcon.classList.add('visible')
                    this.infoShowed = false;
                }
            }
          });
        this.dotsSetup();
    }
    infoBehaviour()
    {
        if(!this.infoShowed)
        {
            this.legendTxt.classList.add('visible');
            this.infoButton.classList.add('selected');
            this.experience.ui.dropState = 1;
            this.resetDrop();
            this.experience.ui.secondIcon.classList.remove('visible')
        }
        else
        {
            this.legendTxt.classList.remove('visible');
            this.infoButton.classList.remove('selected');
            this.experience.ui.dropState = -1;
            this.experience.ui.secondIcon.classList.add('visible')
        }
        this.infoShowed = !this.infoShowed;
    }
    resetInfo()
    {
        this.legendTxt.classList.remove('visible');
        this.infoButton.classList.remove('selected');
        this.experience.ui.secondIcon.classList.add('visible')
        this.infoShowed = false;
    }
    resetDrop()
    {
        this.contentPanel1.classList.remove('visible');
        this.btnLinkPanel1.classList.remove('rot');
        this.panelContentShowed = false;
    }
    closeDrop()
    {
        this.experience.ui.dropState = -1;
        if(this.infoShowed)
            this.resetInfo();
        else
            this.resetDrop();
    }

    selectDot1()
    {
        if(!this.dotState1)
        {
            this.dotContent1.classList.add('open');
            this.dotG1.classList.add('enable');
            this.dotContent2.classList.remove('open');
            this.dotG2.classList.remove('enable');
            this.dotContent3.classList.remove('open');
            this.dotG3.classList.remove('enable');
            this.dotContent4.classList.remove('open');
            this.dotG4.classList.remove('enable');
            this.dotContent5.classList.remove('open');
            this.dotG5.classList.remove('enable');
            this.dotContent6.classList.remove('open');
            this.dotG6.classList.remove('enable');
            this.dotContent7.classList.remove('open');
            this.dotG7.classList.remove('enable');
            this.dotContent8.classList.remove('open');
            this.dotG8.classList.remove('enable');
            this.dotContent9.classList.remove('open');
            this.dotG9.classList.remove('enable');
            this.dotContent10.classList.remove('open');
            this.dotG10.classList.remove('enable');
            this.dotState2 = false;
            this.dotState3 = false;
            this.dotState4 = false;
            this.dotState5 = false;
            this.dotState6 = false;
            this.dotState7 = false;
            this.dotState8 = false;
            this.dotState9 = false;
            this.dotState10 = false;
        }
        else
        {
            this.dotContent1.classList.remove('open');
            this.dotG1.classList.remove('enable');
        }
        this.dotState1 = !this.dotState1;
    }
    selectDot2()
    {
        if(!this.dotState2)
        {
            this.dotContent2.classList.add('open');
            this.dotG2.classList.add('enable');
            this.dotContent1.classList.remove('open');
            this.dotG1.classList.remove('enable');
            this.dotContent3.classList.remove('open');
            this.dotG3.classList.remove('enable');
            this.dotContent4.classList.remove('open');
            this.dotG4.classList.remove('enable');
            this.dotContent5.classList.remove('open');
            this.dotG5.classList.remove('enable');
            this.dotContent6.classList.remove('open');
            this.dotG6.classList.remove('enable');
            this.dotContent7.classList.remove('open');
            this.dotG7.classList.remove('enable');
            this.dotContent8.classList.remove('open');
            this.dotG8.classList.remove('enable');
            this.dotContent9.classList.remove('open');
            this.dotG9.classList.remove('enable');
            this.dotContent10.classList.remove('open');
            this.dotG10.classList.remove('enable');
            this.dotState1 = false;
            this.dotState3 = false;
            this.dotState4 = false;
            this.dotState5 = false;
            this.dotState6 = false;
            this.dotState7 = false;
            this.dotState8 = false;
            this.dotState9 = false;
            this.dotState10 = false;
        }
        else
        {
            this.dotContent2.classList.remove('open');
            this.dotG2.classList.remove('enable');
        }
        this.dotState2 = !this.dotState2;
    }
    selectDot3()
    {
        if(!this.dotState3)
        {
            this.dotContent3.classList.add('open');
            this.dotG3.classList.add('enable');
            this.dotContent1.classList.remove('open');
            this.dotG1.classList.remove('enable');
            this.dotContent2.classList.remove('open');
            this.dotG2.classList.remove('enable');
            this.dotContent4.classList.remove('open');
            this.dotG4.classList.remove('enable');
            this.dotContent5.classList.remove('open');
            this.dotG5.classList.remove('enable');
            this.dotContent6.classList.remove('open');
            this.dotG6.classList.remove('enable');
            this.dotContent7.classList.remove('open');
            this.dotG7.classList.remove('enable');
            this.dotContent8.classList.remove('open');
            this.dotG8.classList.remove('enable');
            this.dotContent9.classList.remove('open');
            this.dotG9.classList.remove('enable');
            this.dotContent10.classList.remove('open');
            this.dotG10.classList.remove('enable');
            this.dotState1 = false;
            this.dotState2 = false;
            this.dotState4 = false;
            this.dotState5 = false;
            this.dotState6 = false;
            this.dotState7 = false;
            this.dotState8 = false;
            this.dotState9 = false;
            this.dotState10 = false;
        }
        else
        {
            this.dotContent3.classList.remove('open');
            this.dotG3.classList.remove('enable');
        }
        this.dotState3 = !this.dotState3;
    }
    selectDot4()
    {
        if(!this.dotState4)
        {
            this.dotContent4.classList.add('open');
            this.dotG4.classList.add('enable');
            this.dotContent1.classList.remove('open');
            this.dotG1.classList.remove('enable');
            this.dotContent3.classList.remove('open');
            this.dotG3.classList.remove('enable');
            this.dotContent2.classList.remove('open');
            this.dotG2.classList.remove('enable');
            this.dotContent5.classList.remove('open');
            this.dotG5.classList.remove('enable');
            this.dotContent6.classList.remove('open');
            this.dotG6.classList.remove('enable');
            this.dotContent7.classList.remove('open');
            this.dotG7.classList.remove('enable');
            this.dotContent8.classList.remove('open');
            this.dotG8.classList.remove('enable');
            this.dotContent9.classList.remove('open');
            this.dotG9.classList.remove('enable');
            this.dotContent10.classList.remove('open');
            this.dotG10.classList.remove('enable');
            this.dotState1 = false;
            this.dotState3 = false;
            this.dotState2 = false;
            this.dotState5 = false;
            this.dotState6 = false;
            this.dotState7 = false;
            this.dotState8 = false;
            this.dotState9 = false;
            this.dotState10 = false;
        }
        else
        {
            this.dotContent4.classList.remove('open');
            this.dotG4.classList.remove('enable');
        }
        this.dotState4 = !this.dotState4;
    }
    selectDot5()
    {
        if(!this.dotState5)
        {
            this.dotContent5.classList.add('open');
            this.dotG5.classList.add('enable');
            this.dotContent1.classList.remove('open');
            this.dotG1.classList.remove('enable');
            this.dotContent3.classList.remove('open');
            this.dotG3.classList.remove('enable');
            this.dotContent4.classList.remove('open');
            this.dotG4.classList.remove('enable');
            this.dotContent2.classList.remove('open');
            this.dotG2.classList.remove('enable');
            this.dotContent6.classList.remove('open');
            this.dotG6.classList.remove('enable');
            this.dotContent7.classList.remove('open');
            this.dotG7.classList.remove('enable');
            this.dotContent8.classList.remove('open');
            this.dotG8.classList.remove('enable');
            this.dotContent9.classList.remove('open');
            this.dotG9.classList.remove('enable');
            this.dotContent10.classList.remove('open');
            this.dotG10.classList.remove('enable');
            this.dotState1 = false;
            this.dotState3 = false;
            this.dotState4 = false;
            this.dotState2 = false;
            this.dotState6 = false;
            this.dotState7 = false;
            this.dotState8 = false;
            this.dotState9 = false;
            this.dotState10 = false;
        }
        else
        {
            this.dotContent5.classList.remove('open');
            this.dotG5.classList.remove('enable');
        }
        this.dotState5 = !this.dotState5;
    }
    selectDot6()
    {
        if(!this.dotState6)
        {
            this.dotContent6.classList.add('open');
            this.dotG6.classList.add('enable');
            this.dotContent1.classList.remove('open');
            this.dotG1.classList.remove('enable');
            this.dotContent3.classList.remove('open');
            this.dotG3.classList.remove('enable');
            this.dotContent4.classList.remove('open');
            this.dotG4.classList.remove('enable');
            this.dotContent5.classList.remove('open');
            this.dotG5.classList.remove('enable');
            this.dotContent2.classList.remove('open');
            this.dotG2.classList.remove('enable');
            this.dotContent7.classList.remove('open');
            this.dotG7.classList.remove('enable');
            this.dotContent8.classList.remove('open');
            this.dotG8.classList.remove('enable');
            this.dotContent9.classList.remove('open');
            this.dotG9.classList.remove('enable');
            this.dotContent10.classList.remove('open');
            this.dotG10.classList.remove('enable');
            this.dotState1 = false;
            this.dotState3 = false;
            this.dotState4 = false;
            this.dotState5 = false;
            this.dotState2 = false;
            this.dotState7 = false;
            this.dotState8 = false;
            this.dotState9 = false;
            this.dotState10 = false;
        }
        else
        {
            this.dotContent6.classList.remove('open');
            this.dotG6.classList.remove('enable');
        }
        this.dotState6 = !this.dotState6;
    }
    selectDot7()
    {
        if(!this.dotState7)
        {
            this.dotContent7.classList.add('open');
            this.dotG7.classList.add('enable');
            this.dotContent1.classList.remove('open');
            this.dotG1.classList.remove('enable');
            this.dotContent3.classList.remove('open');
            this.dotG3.classList.remove('enable');
            this.dotContent4.classList.remove('open');
            this.dotG4.classList.remove('enable');
            this.dotContent5.classList.remove('open');
            this.dotG5.classList.remove('enable');
            this.dotContent6.classList.remove('open');
            this.dotG6.classList.remove('enable');
            this.dotContent2.classList.remove('open');
            this.dotG2.classList.remove('enable');
            this.dotContent8.classList.remove('open');
            this.dotG8.classList.remove('enable');
            this.dotContent9.classList.remove('open');
            this.dotG9.classList.remove('enable');
            this.dotContent10.classList.remove('open');
            this.dotG10.classList.remove('enable');
            this.dotState1 = false;
            this.dotState3 = false;
            this.dotState4 = false;
            this.dotState5 = false;
            this.dotState6 = false;
            this.dotState2 = false;
            this.dotState8 = false;
            this.dotState9 = false;
            this.dotState10 = false;
        }
        else
        {
            this.dotContent7.classList.remove('open');
            this.dotG7.classList.remove('enable');
        }
        this.dotState7 = !this.dotState7;
    }
    selectDot8()
    {
        if(!this.dotState8)
        {
            this.dotContent8.classList.add('open');
            this.dotG8.classList.add('enable');
            this.dotContent1.classList.remove('open');
            this.dotG1.classList.remove('enable');
            this.dotContent3.classList.remove('open');
            this.dotG3.classList.remove('enable');
            this.dotContent4.classList.remove('open');
            this.dotG4.classList.remove('enable');
            this.dotContent5.classList.remove('open');
            this.dotG5.classList.remove('enable');
            this.dotContent6.classList.remove('open');
            this.dotG6.classList.remove('enable');
            this.dotContent2.classList.remove('open');
            this.dotG2.classList.remove('enable');
            this.dotContent7.classList.remove('open');
            this.dotG7.classList.remove('enable');
            this.dotContent9.classList.remove('open');
            this.dotG9.classList.remove('enable');
            this.dotContent10.classList.remove('open');
            this.dotG10.classList.remove('enable');
            this.dotState1 = false;
            this.dotState3 = false;
            this.dotState4 = false;
            this.dotState5 = false;
            this.dotState6 = false;
            this.dotState2 = false;
            this.dotState7 = false;
            this.dotState9 = false;
            this.dotState10 = false;
        }
        else
        {
            this.dotContent8.classList.remove('open');
            this.dotG8.classList.remove('enable');
        }
        this.dotState8 = !this.dotState8;
    }
    selectDot9()
    {
        if(!this.dotState9)
        {
            this.dotContent9.classList.add('open');
            this.dotG9.classList.add('enable');
            this.dotContent1.classList.remove('open');
            this.dotG1.classList.remove('enable');
            this.dotContent3.classList.remove('open');
            this.dotG3.classList.remove('enable');
            this.dotContent4.classList.remove('open');
            this.dotG4.classList.remove('enable');
            this.dotContent5.classList.remove('open');
            this.dotG5.classList.remove('enable');
            this.dotContent6.classList.remove('open');
            this.dotG6.classList.remove('enable');
            this.dotContent2.classList.remove('open');
            this.dotG2.classList.remove('enable');
            this.dotContent8.classList.remove('open');
            this.dotG8.classList.remove('enable');
            this.dotContent7.classList.remove('open');
            this.dotG7.classList.remove('enable');
            this.dotContent10.classList.remove('open');
            this.dotG10.classList.remove('enable');
            this.dotState1 = false;
            this.dotState3 = false;
            this.dotState4 = false;
            this.dotState5 = false;
            this.dotState6 = false;
            this.dotState2 = false;
            this.dotState8 = false;
            this.dotState7 = false;
            this.dotState10 = false;
        }
        else
        {
            this.dotContent9.classList.remove('open');
            this.dotG9.classList.remove('enable');
        }
        this.dotState9 = !this.dotState9;
    }
    selectDot10()
    {
        if(!this.dotState10)
        {
            this.dotContent10.classList.add('open');
            this.dotG10.classList.add('enable');
            this.dotContent1.classList.remove('open');
            this.dotG1.classList.remove('enable');
            this.dotContent3.classList.remove('open');
            this.dotG3.classList.remove('enable');
            this.dotContent4.classList.remove('open');
            this.dotG4.classList.remove('enable');
            this.dotContent5.classList.remove('open');
            this.dotG5.classList.remove('enable');
            this.dotContent6.classList.remove('open');
            this.dotG6.classList.remove('enable');
            this.dotContent2.classList.remove('open');
            this.dotG2.classList.remove('enable');
            this.dotContent8.classList.remove('open');
            this.dotG8.classList.remove('enable');
            this.dotContent9.classList.remove('open');
            this.dotG9.classList.remove('enable');
            this.dotContent7.classList.remove('open');
            this.dotG7.classList.remove('enable');
            this.dotState1 = false;
            this.dotState3 = false;
            this.dotState4 = false;
            this.dotState5 = false;
            this.dotState6 = false;
            this.dotState2 = false;
            this.dotState8 = false;
            this.dotState9 = false;
            this.dotState7 = false;
        }
        else
        {
            this.dotContent10.classList.remove('open');
            this.dotG10.classList.remove('enable');
        }
        this.dotState10 = !this.dotState10;
    }
    dotsSetup()
    {
        this.dot1 = document.querySelector('.dot1-1')        
        this.dotG1 = document.querySelector('.g1-1')
        this.dotContent1 = document.querySelector('.circle1-1')
        this.dot2 = document.querySelector('.dot1-2')
        this.dotG2 = document.querySelector('.g1-2')
        this.dotContent2 = document.querySelector('.circle1-2')
        this.dot3 = document.querySelector('.dot1-3')
        this.dotG3 = document.querySelector('.g1-3')
        this.dotContent3 = document.querySelector('.circle1-3')
        this.dot4 = document.querySelector('.dot1-4')
        this.dotG4 = document.querySelector('.g1-4')
        this.dotContent4 = document.querySelector('.circle1-4')
        this.dot5 = document.querySelector('.dot1-5')
        this.dotG5 = document.querySelector('.g1-5')
        this.dotContent5 = document.querySelector('.circle1-5')
        this.dot6 = document.querySelector('.dot1-6')
        this.dotG6 = document.querySelector('.g1-6')
        this.dotContent6 = document.querySelector('.circle1-6')
        this.dot7 = document.querySelector('.dot1-7')
        this.dotG7 = document.querySelector('.g1-7')
        this.dotContent7 = document.querySelector('.circle1-7')
        this.dot8 = document.querySelector('.dot1-8')
        this.dotG8 = document.querySelector('.g1-8')
        this.dotContent8 = document.querySelector('.circle1-8')
        this.dot9 = document.querySelector('.dot1-9')
        this.dotG9 = document.querySelector('.g1-9')
        this.dotContent9 = document.querySelector('.circle1-9')
        this.dot10 = document.querySelector('.dot1-10')
        this.dotG10 = document.querySelector('.g1-10')
        this.dotContent10 = document.querySelector('.circle1-10')

        this.dotG1.addEventListener("click", ()=>{this.selectDot1()},false)        
        this.dotContent1.addEventListener("click", ()=>{this.selectDot1()},false);
        
        this.dotG2.addEventListener("click", ()=>{this.selectDot2()},false)        
        this.dotContent2.addEventListener("click", ()=>{this.selectDot2()},false);
        
        this.dotG3.addEventListener("click", ()=>{this.selectDot3()},false)        
        this.dotContent3.addEventListener("click", ()=>{this.selectDot3()},false);
        
        this.dotG4.addEventListener("click",()=>{ this.selectDot4()},false)        
        this.dotContent4.addEventListener("click", ()=>{this.selectDot4()},false);
        
        this.dotG5.addEventListener("click", ()=>{this.selectDot5()},false)        
        this.dotContent5.addEventListener("click", ()=>{this.selectDot5()},false);
        
        this.dotG6.addEventListener("click", ()=>{this.selectDot6()},false)        
        this.dotContent6.addEventListener("click", ()=>{this.selectDot6()},false);
        
        this.dotG7.addEventListener("click", ()=>{this.selectDot7()},false)        
        this.dotContent7.addEventListener("click", ()=>{this.selectDot7()},false);
        
        this.dotG8.addEventListener("click", ()=>{this.selectDot8()},false)        
        this.dotContent8.addEventListener("click", ()=>{this.selectDot8()},false);
        
        this.dotG9.addEventListener("click", ()=>{this.selectDot9()},false)        
        this.dotContent9.addEventListener("click", ()=>{this.selectDot9()},false);
        
        this.dotG10.addEventListener("click", ()=>{this.selectDot10()},false)        
        this.dotContent10.addEventListener("click", ()=>{this.selectDot10()},false);       
    }    
    
    segmentIntroEnded()
    {        
        this.enableDots();
        this.linkPanel1.classList.add('visible');
        this.infoContent.classList.add('visible');
    }
    swapToIslandStart()
    {             
        this.linkPanel1.classList.remove('visible');              
        this.disableDots();
        this.infoContent.classList.remove('visible');
    }

    update()
    {        
        this.screenHelpPosition = this.tags['Remolque'].clone();        
        this.screenHelpPosition.add(this.dotOffset1);
        this.screenHelpPosition.project(this.camera.instance)
        this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
        this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
        if(this.translateX > (this.sizes.width-250))        
        {
            this.dot1.classList.remove('visible')  
        }
        else
        {
            this.dot1.classList.add('visible')  
            this.dot1.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)` 
        }

        this.screenHelpPosition = this.tags['Cierre_de_empalme1'].clone();
        //console.log(this.screenHelpPosition);
        this.screenHelpPosition.add(this.dotOffset);
        this.screenHelpPosition.project(this.camera.instance)
        this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
        this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
        if(this.translateX > (this.sizes.width-250))        
        {
            this.dot2.classList.remove('visible')  
        }
        else
        {
            this.dot2.classList.add('visible')  
            this.dot2.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)` 
        }

        this.screenHelpPosition = this.tags['Cable_ADSS'].clone();
        this.screenHelpPosition.add(this.dotOffset);
        this.screenHelpPosition.project(this.camera.instance)
        this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
        this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
        if(this.translateX > (this.sizes.width-250))        
        {
            this.dot3.classList.remove('visible')  
        }
        else
        {
            this.dot3.classList.add('visible')  
            this.dot3.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)` 
        }

        this.screenHelpPosition = this.tags['Cierre_de_empalme2'].clone();
        this.screenHelpPosition.add(this.dotOffset);
        this.screenHelpPosition.project(this.camera.instance)
        this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
        this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
        if(this.translateX > (this.sizes.width-250))        
        {
            this.dot4.classList.remove('visible')  
        }
        else
        {
            this.dot4.classList.add('visible')  
            this.dot4.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)` 
        }

        this.screenHelpPosition = this.tags['Cable_ADSS_anti-tracking001'].clone();
        this.screenHelpPosition.add(this.dotOffset);
        this.screenHelpPosition.project(this.camera.instance)
        this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
        this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
        if(this.translateX > (this.sizes.width-250))        
        {
            this.dot5.classList.remove('visible')  
        }
        else
        {
            this.dot5.classList.add('visible')  
            this.dot5.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)` 
        }

        this.screenHelpPosition = this.tags['Cierre_de_empalme3'].clone();
        this.screenHelpPosition.add(this.dotOffset);
        this.screenHelpPosition.project(this.camera.instance)
        this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
        this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
        if(this.translateX > (this.sizes.width-250))        
        {
            this.dot6.classList.remove('visible')  
        }
        else
        {
            this.dot6.classList.add('visible')  
            this.dot6.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)` 
        }

        this.screenHelpPosition = this.tags['Remate_de_aluminio'].clone();
        this.screenHelpPosition.add(this.dotOffset);
        this.screenHelpPosition.project(this.camera.instance)
        this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
        this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
        if(this.translateX > (this.sizes.width-250))        
        {
            this.dot7.classList.remove('visible')  
        }
        else
        {
            this.dot7.classList.add('visible')  
            this.dot7.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)` 
        }

        this.screenHelpPosition = this.tags['Cierre_de_empalme4'].clone();
        this.screenHelpPosition.add(this.dotOffset);
        this.screenHelpPosition.project(this.camera.instance)
        this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
        this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
        if(this.translateX > (this.sizes.width-250))        
        {
            this.dot8.classList.remove('visible')  
        }
        else
        {
            this.dot8.classList.add('visible')  
            this.dot8.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)` 
        }

        this.screenHelpPosition = this.tags['Cable_ADSS_antirroedor'].clone();
        this.screenHelpPosition.add(this.dotOffset);
        this.screenHelpPosition.project(this.camera.instance)
        this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
        this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
        if(this.translateX > (this.sizes.width-250))        
        {
            this.dot9.classList.remove('visible')  
        }
        else
        {
            this.dot9.classList.add('visible')  
            this.dot9.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)` 
        }

        this.screenHelpPosition = this.tags['Herraje'].clone();
        this.screenHelpPosition.add(this.dotOffset);
        this.screenHelpPosition.project(this.camera.instance)
        this.translateX = this.screenHelpPosition.x * this.sizes.width * 0.5 - 50
        this.translateY = -this.screenHelpPosition.y * this.sizes.height * 0.5 -50
        if(this.translateX > (this.sizes.width-250))        
        {
            this.dot10.classList.remove('visible')  
        }
        else
        {
            this.dot10.classList.add('visible')  
            this.dot10.style.transform =`translateX(${this.translateX}px) translateY(${this.translateY}px)` 
        }
        
    }

    updateDots()
    {
        this.tags = {};
        var counter = 0;
        this.world.segmentOne.modelB.traverse((child)=>
        {           
            //console.log(child.name)
            this.tags[child.name] = new THREE.Vector3();
            child.getWorldPosition(this.tags[child.name]);
            counter++;
        })
        
    }
    enableDots()
    {
        this.dot1.classList.add('visible')
        this.dot2.classList.add('visible')
        this.dot3.classList.add('visible')
        this.dot4.classList.add('visible')
        this.dot5.classList.add('visible')
        this.dot6.classList.add('visible')
        this.dot7.classList.add('visible')
        this.dot8.classList.add('visible')
        this.dot9.classList.add('visible')
        this.dot10.classList.add('visible')
        
    }
    disableDots()
    {
        this.dot1.classList.remove('visible')
        this.dot2.classList.remove('visible')
        this.dot3.classList.remove('visible')
        this.dot4.classList.remove('visible')
        this.dot5.classList.remove('visible')
        this.dot6.classList.remove('visible')
        this.dot7.classList.remove('visible')
        this.dot8.classList.remove('visible')
        this.dot9.classList.remove('visible')
        this.dot10.classList.remove('visible')
    }        
}